export const analyticsActions = {
  SHOW: 'show',
  CLOSE: 'close',
  CLICK: 'click',
};
